<template>
  <Modal ref="baseModal">
    <div
      class="modal-alert modal-alert--show"
      id="modalAlert"
      tabindex="0"
      @keydown.enter.stop.prevent="confirm"
      @keydown.esc.stop.prevent="confirm"
    >
      <div class="modal-alert__wrap">
        <div class="modal-alert__head">
          <h1 class="modal-alert__title">{{title}}</h1>
        </div>
        <div class="modal-alert__body">
          <p class="modal-alert__msg" v-html="content"></p>
        </div>
        <div class="modal-alert__btnArea">
          <button
            id="modal-alert-btn-confirm"
            ref="confirm"
            type="button"
            class="btn-alert-action"
            @click="confirm"
          >{{confirmButtonText}}</button>
        </div>
      </div>
    </div>
  </Modal>
</template>
<script>
import Modal from "@/components/common/Modal.vue";

// WAS 의 에러 응답(JSON)에서 표시 메시지를 만든다.
// - @Valid 검증 실패: 최상위 message + errors[].reason(필드별 사유)을 함께 노출
// - 그 외: message
// - null/문자열/Blob 등 예외 입력은 안전하게 폴백
function buildErrorMessage(data) {
  const FALLBACK = "서버와 통신 중 오류가 발생하였습니다.";
  if (!data || (typeof Blob !== "undefined" && data instanceof Blob)) return FALLBACK;
  if (typeof data === "string") return data || FALLBACK;

  if (Array.isArray(data.errors) && data.errors.length) {
    const details = data.errors
      .map((e) => e && e.reason)
      .filter(Boolean)
      .join("<br>");
    if (details) return details;
  }

  if (data.message) return data.message;
  
  return FALLBACK;
}

export default {
  components: {
    Modal
  },
  data: () => ({
    title: "확인",
    content: "확인해 주세요.",
    confirmButtonText: "확인",
    resolvePromise: undefined
  }),
  methods: {
    closePendingPromise() {
      if (this.resolvePromise) {
        this.$refs.baseModal.close();
        this.resolvePromise(false);
        this.resolvePromise = undefined;
      }
    },
    show(content) {
      // 이전 대기 중인 Promise가 있으면 먼저 닫아줌
      this.closePendingPromise();

      this.setContent(content);
      this.$refs.baseModal.open();
      this.focusConfirmButton();

      return new Promise(resolve => {
        this.resolvePromise = resolve;
      });
    },
    alert(content) {
      return this.show({
        title: "알림",
        content: content,
        confirmButtonText: "확인"
      });
    },
    check(content) {
      return this.show({
        title: "확인",
        content: content,
        confirmButtonText: "확인"
      });
    },
    warn(content) {
      return this.show({
        title: "경고",
        content: content,
        confirmButtonText: "확인"
      });
    },
    confirm() {
      this.$refs.baseModal.close();
      if (this.resolvePromise) {
        this.resolvePromise(true);
        this.resolvePromise = undefined;
      }
    },
    error(error) {
      console.error(error);
      this.closePendingPromise();
      // blob 에러는 commonInterceptor 에서 JSON 으로 정규화됨 → 여기선 분기 불필요
      const data = error && error.response ? error.response.data : null;
      this.setContent({ title: "알림", content: buildErrorMessage(data) });

      this.$refs.baseModal.open();
      this.focusConfirmButton();

      return new Promise((resolve) => {
        this.resolvePromise = resolve;
      });
    },
    focusConfirmButton() {
      this.$nextTick(() => {
        if (this.$refs.confirm) {
          this.$refs.confirm.focus();
        }
      });
    },
    setContent(content) {
      this.title = content.title ? content.title : this.title;
      this.content = content.content ? content.content : this.content;
      this.confirmButtonText = content.confirmButtonText
        ? content.confirmButtonText
        : this.confirmButtonText;
    }
  }
};
</script>
